import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";

export function useLocalCopySyncedByContent<T>(source: T): [T, Dispatch<SetStateAction<T>>] {
  const [localCopy, setLocalCopy] = useState(source);
  const latestSourceRef = useRef(source);
  latestSourceRef.current = source;
  const sourceContent = JSON.stringify(source);

  useEffect(() => {
    setLocalCopy(latestSourceRef.current);
  }, [sourceContent]);

  return [localCopy, setLocalCopy];
}
